import { HTMLAttributes, useEffect, useState } from 'react'

import { WPImage, WPVideo } from '@/types'

export type ResponsiveVideoProps = HTMLAttributes<HTMLElement> &
  Partial<{
    video_desktop: WPVideo
    video_mobile: WPVideo
    poster: WPImage
  }>

const ResponsiveVideo = ({
  video_desktop,
  video_mobile,
  poster,
  ...props
}: ResponsiveVideoProps) => {
  const [videoSrc, setVideoSrc] = useState(
    video_desktop?.url || video_mobile?.url
  )
  const [videoType, setVideoType] = useState(
    video_desktop?.mime_type || video_mobile?.mime_type
  )

  useEffect(() => {
    const updateVideoSource = () => {
      if (window.innerWidth <= 767) {
        setVideoSrc(video_mobile?.url)
        setVideoType(video_mobile?.mime_type)
      } else {
        setVideoSrc(video_desktop?.url)
        setVideoType(video_desktop?.mime_type)
      }
    }

    updateVideoSource() // Controllo iniziale
    window.addEventListener('resize', updateVideoSource)

    return () => window.removeEventListener('resize', updateVideoSource)
  }, [video_desktop, video_mobile])

  if (!videoSrc) return null

  return (
    <video autoPlay muted loop playsInline poster={poster?.url} {...props}>
      <source src={videoSrc} type={videoType} />
    </video>
  )
}

export default ResponsiveVideo
